import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';

export const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ? 'bg-white shadow-md' : 'bg-white/95 backdrop-blur-sm'
    }`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-24">
          {/* Logo - Left Side */}
          <div className="flex-shrink-0">
            <img 
              src="/jcan-logo.png" 
              alt="JCAN Resources LLC" 
              className="h-24 w-auto object-contain"
            />
          </div>

          {/* Desktop Navigation - Centered */}
          <nav className="hidden md:flex items-center space-x-8 absolute left-1/2 transform -translate-x-1/2">
            <button onClick={() => scrollToSection('services')} className="text-[#0f3f5d] hover:text-[#8b2e4a] transition-colors font-medium">
              Services
            </button>
            <button onClick={() => scrollToSection('approach')} className="text-[#0f3f5d] hover:text-[#8b2e4a] transition-colors font-medium">
              Our Approach
            </button>
            <button onClick={() => scrollToSection('values')} className="text-[#0f3f5d] hover:text-[#8b2e4a] transition-colors font-medium">
              Values
            </button>
            <button onClick={() => scrollToSection('contact')} className="text-[#0f3f5d] hover:text-[#8b2e4a] transition-colors font-medium">
              Contact
            </button>
          </nav>

          {/* CTA Button - Right Side */}
          <div className="hidden md:block">
            <Button 
              onClick={() => scrollToSection('contact')}
              className="bg-[#8b2e4a] hover:bg-[#6d2339] text-white"
            >
              Get Started
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-[#0f3f5d]"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-200">
            <nav className="flex flex-col space-y-4">
              <button onClick={() => scrollToSection('services')} className="text-[#0f3f5d] hover:text-[#8b2e4a] transition-colors font-medium text-left">
                Services
              </button>
              <button onClick={() => scrollToSection('approach')} className="text-[#0f3f5d] hover:text-[#8b2e4a] transition-colors font-medium text-left">
                Our Approach
              </button>
              <button onClick={() => scrollToSection('values')} className="text-[#0f3f5d] hover:text-[#8b2e4a] transition-colors font-medium text-left">
                Values
              </button>
              <button onClick={() => scrollToSection('contact')} className="text-[#0f3f5d] hover:text-[#8b2e4a] transition-colors font-medium text-left">
                Contact
              </button>
              <Button 
                onClick={() => scrollToSection('contact')}
                className="bg-[#8b2e4a] hover:bg-[#6d2339] text-white w-full"
              >
                Get Started
              </Button>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};
